import React, { useState } from 'react';
import { formatDateTime, formatLeadSource } from '../../../../utils/functions';
import CommonTable from '../../../global/table';
import CommonCardView from '../../../global/cardView';
import NoRecordFound from '../../../global/noRecordFound';
import CommonDrawer from '../../../global/drawer';
import EnhancedLeadsImportedUserCardView from './EnhancedLeadsImportedUserCardView';
import EnhancedLeadImportedUserDetails from './EnhancedLeadImportedUserDetails';

const EnhancedLeadsImportedUserList = ({
    isLoading,
    leadsImported,
    viewDetail,
    sort,
    setSort,
    viewType,
    onToggleHotLead
}) => {
    const [leadDetails, setLeadDetails] = useState({
        show: false,
        data: null
    });

    // Columns Configuration
    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            sortType: "Name",
            isAvatar: true
        },
        {
            title: "Client Email",
            dataIndex: "userEmail",
            key: "userEmail",
            sortType: "Client Email",
            render: (text) => (
                <p
                    className="text-primary"
                >
                    {text}
                </p>
            ),
        },
        {
            title: "Lead Source",
            dataIndex: "leadSource",
            key: "leadSource",
            sortType: "Lead Source",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sortType: "Email",
        },
        {
            title: "Phone",
            dataIndex: "phone",
            key: "phone",
            sortType: "Phone",
        },
        {
            title: "Event Name",
            dataIndex: "eventName",
            key: "eventName",
            sortType: "Event Name",
        },
        {
            title: "Imported At",
            dataIndex: "importedAt",
            key: "importedAt",
            sortType: "Imported At",
        },
    ];

    // Data Mapping
    const data = Array.isArray(leadsImported) && leadsImported.length > 0
        ? leadsImported.map((item) => ({
            key: item._id,
            id: item._id,
            userEmail: item?.userEmail,
            leadSource: formatLeadSource(item?.leadSource),
            name: item.fullName ? item.fullName : `${item?.firstName} ${item?.lastName}`,
            email: item?.email,
            phone: item?.phone,
            eventName: item?.eventName,
            eventType: item?.eventType,
            eventDate: item?.eventDate,
            eventTime: item?.eventTime,
            guestCount: item?.guestCount,
            company: item?.company,
            address: item?.address,
            importedAt: formatDateTime(item?.createdAt),
            originalData: { ...item }, // Keep original data for viewDetail
            isHotLead: item.isHotLead // Ensure isHotLead is available at top level if needed, or just inside originalData
        }))
        : [];


    return (
        <>
            {data.length > 0 ? (
                <>
                    {viewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={data}
                            sort={sort}
                            setSort={setSort}
                            onRowClick={(record) => setLeadDetails({ show: true, data: record.originalData })}
                        />
                    ) : (
                        <CommonCardView>
                            {data.map((record) => (
                                <EnhancedLeadsImportedUserCardView
                                    key={record.id}
                                    record={record}
                                    onCardClick={(record) => setLeadDetails({ show: true, data: record.originalData })}
                                    onToggleHotLead={onToggleHotLead}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                <NoRecordFound message="No leads imported found." />
            )}
            {
                leadDetails.show && (
                    <CommonDrawer
                        open={leadDetails.show}
                        setOpen={() => setLeadDetails({ show: false, data: null })}
                        title="Lead Details"
                        width={"1000px"}
                        children={
                            <EnhancedLeadImportedUserDetails
                                leadDetail={leadDetails.data}
                                setShowDetail={(show) => setLeadDetails(prev => ({ ...prev, show }))}
                                onToggleHotLead={onToggleHotLead}
                            />
                        }
                    />
                )
            }
        </>
    );
};

export default EnhancedLeadsImportedUserList;
